import Vue from 'vue';

/**
 * Vue Filters
 */
Vue.filter('moment', function(value, format) {
    if (format == 'fromNow') {
        return moment(value).fromNow();
    }
    return moment(value).format(format);
});
Vue.filter('numeral', function(value, format = '0,0.[00]') {
    return numeral(value).format(format);
});
